export default "__VITE_ASSET__HUO5TrIU__"